import { SidebarItem } from '@backstage/core-components';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { usePlatformIncidents } from '../../util/incidents';

/** « Incidents (2) » while incidents are open, refreshed every minute. */
export function IncidentsSidebarItem() {
  const open = usePlatformIncidents().filter(i => !i.resolvedAt).length;
  return (
    <SidebarItem
      icon={ReportProblemOutlinedIcon}
      to="/incidents"
      text={open > 0 ? `Incidents (${open})` : 'Incidents'}
      hasNotifications={open > 0}
    />
  );
}
